/*
 * @Author: shannyHuang
 * @Date: 2022-08-09 23:32:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-25 19:53:48
 * @FilePath: /wemeet-web-activity/src/components/Loading/Loading.js
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import style from './Loading.module.less';

const MLoading = 'https://cdn.calendar.tencent.com/calendar_res/activity/loading.apng';


/**
 * @param: logo 控制组件的Loading效果，circle：转圈圈圆形效果，meeting: 会议M型效果
 * @param: showText 默认的meeting型效果Loading不展示下面的文案，若要展示则传true
 * @returns {JSX.Element}
 */
function Loading(props) {
  const { className, show = false, txt = '加载中...',  logo = 'circle', showText = false } = props;
  const [loadingType, setLoadingType] = useState(logo);
  // 下面文案替换请参考：http://tapd.oa.com/Tencent_Meeting2/prong/stories/view/1020375092870639593
  let displayText = '加载中...';
  if (!['拼命加载中', '拼命加載中', '拼命載入中'].some(text => txt.startsWith(text))) {
    displayText = txt;
  }
  return (
    <>
      {/* 老版本转圈圈的loading效果 */}
      { loadingType === 'circle'
        && <div className={`${style['el-loading']} ${className}`} style={{ display: show ? 'block' : 'none' }}>
          <div className={style['el-loading-mask']}>
            <div className={style['el-loading-spinner']}>
              <svg viewBox="25 25 50 50" className={style.circular}>
                <circle
                  cx="50"
                  cy="50"
                  r="20"
                  fill="none"
                  className={style.path}
                />
              </svg>
              <p className={style['el-loading-text']}>{displayText}</p>
            </div>
          </div>
        </div>
      }

      {/* 会议M型Loading效果 */}
      { loadingType === 'meeting'
        && <div className={`${style['el-loading']} ${className}`} style={{ display: show ? 'block' : 'none' }}>
          <div className={style['el-loading-mask']}>
            <div className={style['el-loading-spinner']}>
            <img src={MLoading} alt={'加载中...'} onError={() => setLoadingType('circle')} />
              {!!showText && <p className={style['el-loading-text']}>{displayText || '加载中....'}</p>}
            </div>
          </div>
        </div>
      }
    </>
  );
}

Loading.show = (props) => {
  if (typeof window === 'undefined') return;
  const { txt = '加载中...', id = 'el-loading', show = true, logo = 'meeting', showText = false  } = props || {};
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('div');
    el.id = id;
    document.body.appendChild(el);
  }
  ReactDOM.render(<Loading show={show} txt={txt} logo={logo} showText={showText}/>, el);
};

Loading.close = (props) => {
  if (typeof window === 'undefined') return;
  const { id = 'el-loading' } = props || {};
  Loading.show({
    txt: '',
    id,
    show: false,
  });
};

Loading.propTypes = {
  className: PropTypes.string,
  show: PropTypes.bool,
  txt: PropTypes.string,
  logo: PropTypes.string,
  showText: PropTypes.bool,
  inContentBodyOnly: PropTypes.bool,
};

export default Loading;
